import { FC, PropsWithChildren, useEffect } from 'react';

import useLocale from '@/hooks/use-locale';
import { useKeycloak } from '@/providers/keycloak-provider';

const RoleGuardProvider: FC<PropsWithChildren> = ({ children }) => {
  const { keycloak } = useKeycloak();
  // Not derived from the pathname: `/access-denied` only exists under `[locale]`, and the
  // root `/` landing page has no locale segment to read.
  const locale = useLocale();

  useEffect(() => {
    if (
      keycloak?.authenticated &&
      (keycloak.hasRealmRole('admin') || keycloak.hasResourceRole('service'))
    ) {
      keycloak.logout({ redirectUri: `${window.location.origin}/${locale}/access-denied` });
    }
  }, [keycloak, locale]);
  return children;
};

export default RoleGuardProvider;
